<template>
  <div>
    <span class="font-12 font-weight-medium">Pedidos em Aberto</span>

    <div class="overflow-y-auto">
      <table id="tabela-entradas-futuras">
        <tr>
          <th v-for="cab in cabecalhos">{{ cab.text }}</th>
        </tr>

        <tr v-for="pedido in pedidos_em_aberto">
          <td v-for="cabecalho in cabecalhos">
            <template v-if="cabecalho.formatar">
              {{ cabecalho.converter_embalagem ? Helpers.formatarValor(converteEmbalagemValor(pedido[cabecalho.value])) : Helpers.formatarValor(pedido[cabecalho.value]) }}
            </template>

            <template v-else>{{ pedido[cabecalho.value] }}</template>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "PedidosEmAberto",
  props: {
    pedidos_em_aberto: Array,
    dados_conversao: Object
  },
  data: () => ({
    cabecalhos: [
      { text: 'PC', value: 'id_solicitacao' },
      { text: 'Dt. Solicitação', value: 'data_solicitacao' },
      { text: 'Dt. Prevista', value: 'data_previsao' },
      { text: 'Qtde.', value: 'qtde', formatar: true, converter_embalagem: true },
      { text: 'Pendente', value: 'qtde_pendente', formatar: true, converter_embalagem: true },
      { text: 'Status', value: 'status' },
      { text: 'Ranking', value: 'ranking' },
    ],
  }),
  computed: {
    ...mapGetters({
      embalagemMasterAtivada: "EmbalagemTelaDeCompras/getEmbalagemMaster",
    }),
  },
  methods: {
    converteEmbalagemValor(valor) {
      const multiplo_compra = this.dados_conversao.multiplo_compra || 1;

      if (this.dados_conversao.tipo_fator_conversao === 'D') {
        return this.embalagemMasterAtivada ? (valor / multiplo_compra) : valor;
      }

      return this.embalagemMasterAtivada ? (valor * multiplo_compra) : valor;
    },
  }
}
</script>

<style scoped>
#tabela-entradas-futuras {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  color: #595959;
}
#tabela-entradas-futuras tr th {
  background: #e3efff;
}
#tabela-entradas-futuras tr th, tr td {
  border: 1px solid #e1dfdf;
  padding: 0 2px;
  text-align: center;
}
</style>
